import { render, staticRenderFns } from "./Bulletins.vue?vue&type=template&id=cca3d10a&scoped=true"
import script from "./Bulletins.vue?vue&type=script&lang=js"
export * from "./Bulletins.vue?vue&type=script&lang=js"
import style0 from "./Bulletins.vue?vue&type=style&index=0&id=cca3d10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca3d10a",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QSpace,QBtn,QMenu,QList,QItem,QItemSection,QCheckbox,QSeparator,QIcon,QDialog,QCard,QForm,QInput,QEditor,QSelect,QBadge,QCardSection,QTooltip,QItemLabel});qInstall(component, 'directives', {ClosePopup});
